import React, { FC, useCallback, useEffect, useState } from 'react'
import { Button } from '@wmgtech/legato'

import { useFormContext } from 'react-hook-form'
import { rules } from 'modulesCommon/ProductTable/constants'
import { FormSelect } from 'components/Form'
import { IProductForm } from 'modules/ProjectCreate/types'
import { formatDate } from 'shared/utils/formatDate'
import { usePrevious } from 'shared/hooks'
import { capitalizeFirstLetter } from 'shared/utils/capitalizeFirstLetter'
import { ProductTitleField } from 'modules/ProjectEdit/components/ProductTable/Fields/ProductTitleField'
import { PRODUCT_CONFIGURATION_OPTIONS, PRODUCT_TRACK_STATUS_OPTIONS } from 'shared/consts'
import { IRowFormProps } from './RowForm.props'
import { ReleaseDateField } from 'modules/ProjectEdit/components/ProductTable/Fields'

const RowForm: FC<IRowFormProps> = ({
  product,
  idx,
  handleRowClose,
  handleAddProduct
}) => {
  const [defaultProduct, setDefaultProduct] = useState(product)

  const { control, watch, setValue } = useFormContext<IProductForm>()
  const { configuration, name, publish_date } = product

  const configurationValue = watch(`products.${idx}.configuration`)
  const prevConfigurationValue = usePrevious(configurationValue)

  useEffect(() => {
    setDefaultProduct(product)
  }, [product])

  useEffect(() => {
    if (prevConfigurationValue && configurationValue !== prevConfigurationValue) {
      setValue(`products.${idx}.name`, '')
    }
  }, [idx, setValue, configurationValue, prevConfigurationValue])

  const onHandleRowClose = useCallback(() => {
    handleRowClose(idx, product.isSaved ? defaultProduct : null)
  }, [idx, defaultProduct, product, handleRowClose])

  return (
    <div className="product-table__item">
      <div className="product-table__col product-table__col--type">
        {
          !product?.gpid_list ? (
            <FormSelect
              placeholder="Start typing Type..."
              control={control}
              fieldName={`products.${idx}.configuration`}
              options={PRODUCT_CONFIGURATION_OPTIONS}
              rules={rules?.configuration}
            />
          ) : (<div>{capitalizeFirstLetter(configuration)}</div>)
        }
      </div>
      <div className="product-table__col product-table__col--name">
        {!product?.gpid_list ? <ProductTitleField idx={idx} disabled={!!product?.gpid_list} /> : <div>{name}</div>}
      </div>
      <div className="product-table__col product-table__col--status">
        <FormSelect
          control={control}
          placeholder="-- No Track Status--"
          fieldName={`products.${idx}.gps_status`}
          options={PRODUCT_TRACK_STATUS_OPTIONS}
        />
      </div>
      <div className="product-table__col product-table__col--date">
        {
          !product?.gpid_list ? (
            <ReleaseDateField idx={idx} />
          ) : <div>{formatDate({ date: new Date(publish_date), withTime: false })}</div>
        }
      </div>
      <div className="product-table__actions product-table__col product-table__col--actions">
        <Button colorType="info" containerStyle="link" icon="xmark" onClick={onHandleRowClose} />
        <Button colorType="info" containerStyle="link" icon="check" onClick={() => handleAddProduct(idx)} />
      </div>
    </div>
  )
}

export default RowForm
